import type { ExpenseExpectationDto } from '@/api/backend/users/applications';
import { convertExpensePeriod } from '@/helpers/convertExpensePeriod';
import { convertPeriod } from '@/helpers/convertPeriod';
import type { ApplicantExpense, ExpensePeriodicValue, Financials, PeriodicValue, PeriodKey } from '@/types';

// Convert frontend frequency to backend API format
const toApiFrequency = (frontendFreq: PeriodKey): ExpenseExpectationDto['frequency'] => {
  const map: Record<PeriodKey, ExpenseExpectationDto['frequency']> = {
    week: 'weekly',
    fortnight: 'fortnightly',
    month: 'monthly',
    quarter: 'quarterly',
    year: 'annually',
  };
  return map[frontendFreq] || 'monthly';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fundsExpenses = (data: Financials, applicantIndex: number): any[] => {
  let expenses = data.expenses;
  const apiExpenses = [];
  if (expenses) {
    if (expenses.fundsExpenses) {
      expenses = { ...expenses, ...expenses.fundsExpenses };
      for (const [propertyKey, propertyValue] of Object.entries(expenses)) {
        if (['numberOfDependants', 'predictedExpenseChange', 'fundsExpenses'].includes(propertyKey)) continue;

        const expenseTypeId = (propertyValue as ExpensePeriodicValue)?.expenseTypeId;
        if (propertyKey && expenseTypeId)
          apiExpenses.push({
            applicantIndex,
            expenseTypeId,
            expenseAmount: convertExpensePeriod(propertyValue, 'month').amount,
          });
      }
    } else {
      for (const [propertyKey, propertyValue] of Object.entries(expenses)) {
        if (['numberOfDependants', 'predictedExpenseChange'].includes(propertyKey)) continue;

        const expenseTypeId = (propertyValue as ExpensePeriodicValue)?.expenseTypeId;
        if (propertyKey && expenseTypeId)
          apiExpenses.push({
            applicantIndex,
            expenseTypeId,
            expenseAmount: convertPeriod(propertyValue as PeriodicValue, 'month').amount,
          });
      }
    }
  }
  return apiExpenses;
};

export const expenseExpectation = (data: ApplicantExpense | null, applicantIndex: number): ExpenseExpectationDto[] =>
  data && data?.predictedExpenseChange?.amount
    ? [
        {
          applicantIndex,
          changesInLivingExpenses: data.changesInLivingExpense,
          expenseChangeReason: data.expenseChangeReason,
          expenseAmount: data.predictedExpenseChange.amount,
          frequency: toApiFrequency(data.predictedExpenseChange.frequency),
        },
      ]
    : [];
